import { render } from "./SingleEvent.vue?vue&type=template&id=908c6e8a&scoped=true"
import script from "./SingleEvent.vue?vue&type=script&lang=js"
export * from "./SingleEvent.vue?vue&type=script&lang=js"

import "./SingleEvent.vue?vue&type=style&index=0&id=908c6e8a&lang=scss&scoped=true"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908c6e8a"]])

export default __exports__